import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { noop } from 'helpers/GlobalHelper';
import OverlayFooter from 'components/OverlayFooter';
import Style from './SignupSuccess.module.scss';
import Header from '../Header';

const SignupSuccess = ({
  language,
  onClose,
  onMvpdStart,
  optimizelyLanguageStrings,
  renderLogo,
  useMVPDLoginProfile,
}) => {
  const {
    profileCreate_successButton: successButtonText,
    profileCreate_successHeader: headerText,
    profileCreate_successText: successText,
  } = language || {};

  const buttonComponent = ({ buttonText, buttonClick }) => (
    <button onClick={buttonClick} className={Style.btnPrimary}>
      {buttonText}
    </button>
  );
  buttonComponent.propTypes = {
    buttonText: PropTypes.string,
    buttonClick: PropTypes.func,
  };
  buttonComponent.defaultProps = {
    buttonText: null,
    buttonClick: noop,
  };

  // Optimizely Experiment to prompt MVPD login after sign up
  const optimizelyMVPDLoginButtonText = _.get(
    optimizelyLanguageStrings,
    'profile_connectMVPDButtonText',
    'Connect my TV Provider',
  );
  const optimizelyCloseButtonText = _.get(
    optimizelyLanguageStrings,
    'profile_closeButtonText',
    'Maybe Later',
  );
  const mvpdLoginButton =
    useMVPDLoginProfile &&
    buttonComponent({
      buttonText: optimizelyMVPDLoginButtonText,
      buttonClick: onMvpdStart,
    });
  const maybeLaterLink = (
    <span onClick={onClose} className={Style.maybeLaterLink}>
      {optimizelyCloseButtonText}
    </span>
  );

  const closeOverlayButton = useMVPDLoginProfile
    ? maybeLaterLink
    : buttonComponent({
        buttonText: successButtonText,
        buttonClick: onClose,
      });

  return (
    <main className={Style.SignUpSuccess}>
      <Header onClose={onClose} renderLogo={renderLogo} />
      <div className={Style.container}>
        <div className={Style.contentWrap}>
          <h1 className={Style.signupSuccessHeaderText}>{headerText}</h1>
          <p className={Style.signupSuccessText}>{successText}</p>
          {mvpdLoginButton}
          {closeOverlayButton}
        </div>
      </div>
      <OverlayFooter language={language} />
    </main>
  );
};

SignupSuccess.defaultProps = {
  language: {},
  onMvpdStart: noop,
  optimizelyLanguageStrings: noop,
  useMVPDLoginProfile: false,
};

SignupSuccess.propTypes = {
  language: PropTypes.shape({
    profileCreate_successButton: PropTypes.string,
    profileCreate_successHeader: PropTypes.string,
    profileCreate_successText: PropTypes.string,
  }),
  onClose: PropTypes.func.isRequired,
  onMvpdStart: PropTypes.func,
  optimizelyLanguageStrings: PropTypes.func,
  renderLogo: PropTypes.func.isRequired,
  useMVPDLoginProfile: PropTypes.bool,
};

export default SignupSuccess;
